exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".community-button_community-button_2Lo_g {\n    box-shadow: 0 0 0 1px var(--ui-black-transparent, hsla(55, 20%, 20%, 0.15));\n}\n.community-button_community-button-icon_1IFvv {\n    height: 1.25rem;\n}\n", ""]);

// exports
exports.locals = {
	"community-button": "community-button_community-button_2Lo_g",
	"communityButton": "community-button_community-button_2Lo_g",
	"community-button-icon": "community-button_community-button-icon_1IFvv",
	"communityButtonIcon": "community-button_community-button-icon_1IFvv"
};